<button
  class="btn"
  [attr.data-testid]="testId()"
  [disabled]="disabled || isLoading"
  [id]="id"
  [matTooltip]="tooltip"
  [ngClass]="[
    disabled || isLoading ? 'btn--disable' : 'btn--' + color,
    color === 'outlined' ? 'outlined-' + size : 'size-' + size,
  ]"
  [ngStyle]="{ width, height }"
  [tabIndex]="tab"
  [type]="type"
>
  @if (isLoading) {
    <app-spinner [size]="size" />
  }
  @if (icon) {
    <mat-icon [ngStyle]="{ width: icon.size, height: icon.size }" [svgIcon]="icon.iconName" />
  }
  <ng-content />
</button>
